// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__dXsU3","gfeWrapper":"CalendarEvent_gfeWrapper__3N0JC"};